export enum CourseStudentTypeEnum {
    RESIT = 'RESIT',
    EXEMPTION = 'EXEMPTION',
    APPLICATION = 'APPLICATION',
}
